import { useNuxtApp } from '#imports'
import { ref } from 'vue'

export function useIsHydrationCompleted() {
  const app = useNuxtApp()

  const completed = ref(false)
  app.hook('page:loading:end', () => {
    completed.value = true
  })

  return completed
}
